import { useTranslation } from 'react-i18next';
import { Check, X } from 'lucide-react';
import { StatusOrdemServico, getStatusOSLabels } from '@/types/ordemServico';

type StatusComDisponivel = StatusOrdemServico | 'disponiveis';

interface StatusBadgeOSProps {
  status: StatusComDisponivel;
  className?: string;
}

/**
 * Status da OS — marcador colorido (dot/✓/✕) + label, sem fundo nem borda.
 * Cores alinhadas com o Kanban (verde/roxo/vermelho).
 */
export function StatusBadgeOS({ status, className }: StatusBadgeOSProps) {
  const { t } = useTranslation();
  const STATUS_OS_LABELS = getStatusOSLabels(t);
  const label = STATUS_OS_LABELS[status];

  const base = `inline-flex items-center gap-1.5 text-xs font-semibold ${className ?? ''}`;

  if (status === 'concluida') {
    return (
      <span className={base}>
        <Check size={12} strokeWidth={3} style={{ color: '#22C55E' }} />
        {label}
      </span>
    );
  }
  if (status === 'cancelada' || status === 'recusada') {
    return (
      <span className={base}>
        <X size={12} strokeWidth={3} style={{ color: '#EF4444' }} />
        {label}
      </span>
    );
  }

  const palette: Record<string, { color: string; pulse: boolean }> = {
    disponiveis: { color: '#22C55E', pulse: true }, // verde
    pendente: { color: '#22C55E', pulse: true }, // verde (sem prestador = disponível)
    aceita: { color: '#8B5CF6', pulse: true }, // roxo
    em_execucao: { color: '#EF4444', pulse: true }, // vermelho
  };
  const cfg = palette[status] || { color: 'hsl(var(--foreground))', pulse: false };

  return (
    <span className={base}>
      <span
        className={`inline-block w-2 h-2 rounded-full${cfg.pulse ? ' status-pill__led--pulse' : ''}`}
        style={{ background: cfg.color }}
        aria-hidden
      />
      {label}
    </span>
  );
}
